import React from "react";
import { Chart, registerables } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import Bottom from "../../navbar/Bottom";

Chart.register(...registerables);

const GaugeDoughnut = ({
	id,
	className,
	valueChart,
	chartColor,
	chartLabel,
	skor,
	legend = false,
	description = null,
	children,
	width
}) => {
	const plugins = {
		id: id,
		afterDatasetDraw: (chart) => {
			const { ctx, data } = chart;

			ctx.save();
			const meterValue = data.datasets[0].meterValue;

			const cx = chart._metasets[0].data[0].x;
			const cy = chart._metasets[0].data[0].y;

			const label = data.datasets[0].label;
			if (label) {
				ctx.font = "bold 16px sans-serif";
				ctx.fillStyle = "#212121";
				ctx.textAlign = "center";
				ctx.fillText(label, cx, 24);
			}

			ctx.font = "bold 32px sans-serif";
			ctx.fillStyle = "#757575";
			ctx.textAlign = "center";
			ctx.fillText(meterValue, cx, cy - 20);

			ctx.font = "normal 10px sans-serif";
			ctx.fillStyle = "#333333";

			if (description) {
				ctx.font = "bold 12px sans-serif";
				ctx.fillStyle = "#424242";
				ctx.fillText(description, cx, cy + 24);
			}

			ctx.restore();
		},
	};
	const options = {
		options: {
			aspectRatio: 1,
			responsive: true,
			layout: {
				padding: {
					top: 0,
					Bottom: 0,
				},
			},
			plugins: {
				legend: {
					display: false,
				},
				title: {
					display: false,
				},
			},
		},
	};

	const data = {
		labels: "",
		datasets: [
			{
				label: chartLabel,
				data: valueChart,
				backgroundColor: chartColor,
				meterValue: skor,
				cutout: "75%",
				circumference: 180,
				rotation: -90,
			},
		],
	};

	return (
		<div
			className={className}
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Doughnut data={data} plugins={[plugins]} options={options} width={width}/>
			{children}
		</div>
	);
};

export default GaugeDoughnut;
